module.exports = {
  comments: [
    {
      id: 1,
      parent_id: null,
      content: '<p>Main comment 1</p>',
      user: {
        id: 10,
        name: 'Name Surname 1',
        profile_photo:
          'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
      },
      num_likes: 5,
      date: '2020-08-27T21:22:18.579397Z',
      replies: [
        {
          id: 2,
          parent_id: 1,
          content: '<p>Reply 1</p>',
          user: {
            id: 11,
            name: 'Name Surname 2',
            profile_photo:
              'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
          },
          num_likes: 1,
          date: '2020-08-27T21:22:18.579397Z',
          replies: [
            {
              id: 3,
              parent_id: 2,
              content: '<p>Reply 3</p>',
              user: {
                id: 12,
                name: 'Name Surname 2',
                profile_photo:
                  'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
              },
              num_likes: 10,
              date: '2020-08-27T21:22:18.579397Z',
              replies: [],
            },
            {
              id: 5,
              parent_id: 2,
              content: '<p>Reply 5</p>',
              user: {
                id: 13,
                name: 'Name Surname 5',
                profile_photo:
                  'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
              },
              num_likes: 5,
              date: '2020-08-27T21:22:18.579397Z',
              replies: [],
            },
          ],
        },
        {
          id: 4,
          parent_id: 1,
          content: '<p>Reply 4</p>',
          user: {
            id: 14,
            name: 'Name Surname 4',
            profile_photo:
              'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
          },
          num_likes: 5,
          date: '2020-08-27T21:22:18.579397Z',
          replies: [],
        },
      ],
    },
    {
      id: 6,
      parent_id: null,
      content: '<p>Main comment 2</p>',
      user: {
        id: 15,
        name: 'Name Surname 6',
        profile_photo:
          'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
      },
      num_likes: 5,
      date: '2020-08-27T21:22:18.579397Z',
      replies: [
        {
          id: 7,
          parent_id: 6,
          content: '<p>Reply 7</p>',
          user: {
            id: 16,
            name: 'Name Surname 7',
            profile_photo:
              'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
          },
          num_likes: 5,
          date: '2020-08-27T21:22:18.579397Z',
          replies: [],
        },
        {
          id: 8,
          parent_id: 6,
          content: '<p>Reply 8</p>',
          user: {
            id: 17,
            name: 'Name Surname 8',
            profile_photo:
              'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
          },
          num_likes: 5,
          date: '2020-08-27T21:22:18.579397Z',
          replies: [
            {
              id: 9,
              parent_id: 8,
              content: '<p>Reply 9</p>',
              user: {
                id: 18,
                name: 'Name Surname 9',
                profile_photo:
                  'https://iconarchive.com/download/i45783/tatice/cristal-intense/Apple.ico',
              },
              num_likes: 5,
              date: '2020-08-27T21:22:18.579397Z',
              replies: [],
            },
          ],
        },
      ],
    },
  ],
};
